import { useTranslation } from 'react-i18next'

import { Box, Icon, Typography, type IconProps } from '@percent/lemonade'
import classes from './PlatformTourItems.module.scss'

type PlatformTourItemProps = Readonly<{
  title: string
  subtitle: string
  icon: IconProps['name']
}>

function PlatformTourItem({ title, subtitle, icon }: PlatformTourItemProps) {
  return (
    <Box className={classes.platformTourItem}>
      <Box className={classes.iconColumn}>
        <Box className={classes.iconWrapper}>
          <Icon name={icon} size={6} color="primary" />
        </Box>
      </Box>
      <Box className={classes.contentColumn}>
        <Typography variant="default-bold">{title}</Typography>
        <Typography variant="default" color="gray400">
          {subtitle}
        </Typography>
      </Box>
    </Box>
  )
}

export function FullFeaturedPlatformTourItems() {
  const { t } = useTranslation()

  return (
    <Box className={classes.platformTourItems}>
      <PlatformTourItem
        title={t('workplace_giving.onboarding.platform_tour.items.support_causes.title')}
        subtitle={t('workplace_giving.onboarding.platform_tour.items.support_causes.subtitle')}
        icon="love-it-hand-give-2"
      />
      <PlatformTourItem
        title={t('workplace_giving.onboarding.platform_tour.items.get_involved.title')}
        subtitle={t('workplace_giving.onboarding.platform_tour.items.get_involved.subtitle')}
        icon="earth-outline"
      />
      <PlatformTourItem
        title={t('workplace_giving.onboarding.platform_tour.items.track_journey.title')}
        subtitle={t('workplace_giving.onboarding.platform_tour.items.track_journey.subtitle')}
        icon="stonks"
      />
    </Box>
  )
}

export function DonationsOnlyPlatformTourItems() {
  const { t } = useTranslation()

  return (
    <Box className={classes.platformTourItems}>
      <PlatformTourItem
        title={t('workplace_giving.onboarding.platform_tour.items.explore_causes.title')}
        subtitle={t('workplace_giving.onboarding.platform_tour.items.explore_causes.subtitle')}
        icon="check-badge-outline"
      />
      <PlatformTourItem
        title={t('workplace_giving.onboarding.platform_tour.items.security.title')}
        subtitle={t('workplace_giving.onboarding.platform_tour.items.security.subtitle')}
        icon="shield-lock"
      />
      <PlatformTourItem
        title={t('workplace_giving.onboarding.platform_tour.items.easy_tracking.title')}
        subtitle={t('workplace_giving.onboarding.platform_tour.items.easy_tracking.subtitle')}
        icon="stonks"
      />
    </Box>
  )
}

export function VolunteeringOnlyPlatformTourItems() {
  const { t } = useTranslation()

  return (
    <Box className={classes.platformTourItems}>
      <PlatformTourItem
        title={t('workplace_giving.onboarding.platform_tour.items.explore_volunteering.title')}
        subtitle={t('workplace_giving.onboarding.platform_tour.items.explore_volunteering.subtitle')}
        icon="volunteering-calendar-minimal"
      />
      <PlatformTourItem
        title={t('workplace_giving.onboarding.platform_tour.items.track_impact.title')}
        subtitle={t('workplace_giving.onboarding.platform_tour.items.track_impact.subtitle')}
        icon="stonks"
      />
      <PlatformTourItem
        title={t('workplace_giving.onboarding.platform_tour.items.bring_coworkers.title')}
        subtitle={t('workplace_giving.onboarding.platform_tour.items.bring_coworkers.subtitle')}
        icon="bolt-exploding"
      />
    </Box>
  )
}
